import React, { Component, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../css/style.css";
import "../css/purpleresponsive.css";
import renderHTML from "react-render-html";
import $ from "jquery";
import { apiCalling, awsAPIUrlcommon, apiCallingWithoutToken } from "../apiService";
import "react-datepicker/dist/react-datepicker.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SlotList from "../home/slotList";
import { Helmet } from "react-helmet";
import Star from "../image/ida/star-details.png"
import DoctorImg from "../image/ida/doctor.png"
import Bookappointment from "../Sparsh/bookappointment"
import { IoCallOutline, IoGlobe, IoMail } from "react-icons/io5";
import { HiOutlineEnvelope } from "react-icons/hi2";
import { SlLocationPin } from "react-icons/sl";
import { RiArrowRightSLine } from "react-icons/ri";
import Stimg from "../image/ida/stethoscope_bl.png"
import Groupimg from "../image/ida/group-bl.png"
import Serviceimg from "../image/ida/services.png"
import Arrowleft from "../image/ida/Arrow_left_light.png"
import { authHelper, setIsAuthenticated } from "../utilis/authHelper";
import { Link } from "react-router-dom/cjs/react-router-dom";
import HealthDocumentList from "./health-document-list";
import GallerySlider from "./image-gallery";
const folderName = window.sessionStorage.getItem("homeName");
// const Header = React.lazy(() => import("../" + folderName + "/header"));
// const Footer = React.lazy(() => import("../" + folderName + "/footer"));

const inperson =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/inperson.png";
const chatg =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/chatg.png";
const phoneg =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/phoneg.png";
const videog =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/videog.png";
const info =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/infosquare.png";
const speciality =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/stethoscope.png";
const service =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/checklist1.png";
const hospital =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/hospitals.png";
export default class DoctorDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      professionalStatement: "",
      doctorBD: [],
      drSpecialization: [],
      hospitalDetails: [],
      drServices: [],
      appointmentSlotDay: [],
      hospitalImages: [],
      serviceOffered: [],
      Specialities: [],
      officeDetails: [],
      testing: "yyy",
      calFlag: "",
      seoTitle: "",
      description: "",
      selectedTab: 0,
      appType: window.sessionStorage.getItem("flagOption"),
      homeName: window.sessionStorage.getItem("homeName"),
      healthRecords: [],
      hospitalArray: [],
      isLoading:true
    };
    this.goToAppointment = this.goToAppointment.bind(this);
  }

  isLoginCheck() {
    if (folderName === "IMAHospitals") {
      return true;
    } else {
      let flag = true;
      if (!window.sessionStorage.getItem("isLogin")) {
        $("#ForgotPasswordWrap").hide();
        $("#SignupWrap").hide();
        $("#signInWrapDiv").hide();
        flag = false;
      }
      return flag;
    }
  }

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
    $(".react-datepicker__time-container").show();
    $(".react-datepicker__navigation").hide();
    $(".timeClose").show();
  };
  addToFavourites(e) {
    if (this.isLoginCheck() === true) {
      if (e.target.checked) {
        const jsonData = {
          method: "POST",
          body: JSON.stringify({
            functionName: "addToFavourites",
            siteId: window.sessionStorage.getItem("siteId"),
            userId: authHelper.getUserId(),
            favouriteUserId: this.state.doctorBD.userId,
          }),
        };
        apiCallingWithoutToken(jsonData).then((data) => {
          if (data.success === "1") {
            alert(data.successMessage);
          }
        });
        $("#fav").attr("disabled", true);
      }
    }
  }
  DrDetailLiked() {
    $("#dr-detail-liked .imgdislike").toggle();
    $("#dr-detail-liked .imgliked").toggle();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.match.url !== this.props.match.url) window.location.reload();
  }
  callSiteRequest() {
    let siteurl = "";
    window.sessionStorage.setItem("pathname", window.location.pathname);
    if (!this.state.siteId) {
      siteurl = this.state.siteUrl;
    } else {
      window.sessionStorage.setItem("siteId", this.state.siteId);
    }
    const siteCallRequest = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getSiteDetails",
        siteId: this.state.siteId,
        siteUrl:window.location.host,
      }),
    };
    apiCallingWithoutToken(siteCallRequest).then((data) => {
      // NEW: Check if component is mounted
      if (!this.isMounted_) return;
      if (data.success === "1") {
        var folder = data.siteDetailsData[0].siteData[0].themeName;
        let is_theme_based = data.siteDetailsData[0].siteData[0].is_theme_based;
        let project_folder = data.siteDetailsData[0].siteData[0]?.project_folder
          ? data.siteDetailsData[0].siteData[0]?.project_folder
          : "DoctorsCabin";
        if (data.siteDetailsData[0].siteData[0].id) {
        } else {
          folder = "DoctorsCabin";
        }
        window.sessionStorage.setItem("homeName", folder);
        // NEW: Update state and set loading to false
        this.setState({
          homeName: folder,
          isLoading: false,
        });
        if (is_theme_based === false && project_folder !== "") {
          folder = project_folder;
        } else {
          folder = data.siteDetailsData[0].siteData[0].themeName;
        }
        if (data.siteDetailsData[0].siteData[0].id) {
        } else {
          folder = "DoctorsCabin";
        }
        //folder = 'SAANVI'
        window.sessionStorage.setItem(
          "siteId",
          data.siteDetailsData[0].siteData[0].id
        );
        window.sessionStorage.setItem(
          "themeId",
          data.siteDetailsData[0].siteData[0].themeId
        );
        window.sessionStorage.setItem(
          "themeName",
          data.siteDetailsData[0].siteData[0].themeName
        );
        window.sessionStorage.setItem("themeVersion", "0");
        window.sessionStorage.setItem("homeName", folder);
        //  window.sessionStorage.setItem("homeName", "ida");
        window.sessionStorage.setItem("reload", "1");
        window.sessionStorage.setItem(
          "dashboard_html",
          data.siteDetailsData[0].siteData[0].dashboard_html
        );
        window.sessionStorage.setItem(
          "theme_custom_color",
          data.siteDetailsData[0].siteData[0].theme_custom_color
        );
        window.sessionStorage.setItem(
          "contact_emailId",
          data.siteDetailsData[0].siteData[0].emailId
        );
        window.sessionStorage.setItem(
          "contact_no",
          data.siteDetailsData[0].siteData[0].contact_no
        );
        window.sessionStorage.setItem(
          "fav_icon",
          data.siteDetailsData[0].siteData[0].fav_icon
        );
        window.sessionStorage.setItem(
          "seo_description",
          data.siteDetailsData[0].siteData[0].seo_description
        );
        window.sessionStorage.setItem(
          "seo_keywords",
          data.siteDetailsData[0].siteData[0].seo_keywords
        );
        window.sessionStorage.setItem(
          "seo_title",
          data.siteDetailsData[0].siteData[0].seo_title
        );
        window.sessionStorage.setItem(
          "slug",
          data.siteDetailsData[0].siteData[0].slug
        );
        window.sessionStorage.setItem(
          "isIDALogin",
          data.siteDetailsData[0].siteData[0].isIDALogin
        );
        //window.sessionStorage.setItem("google_analytics_script",data.siteDetailsData[0].siteData[0].google_analytics_script);
        var google_analytics_script =
          data.siteDetailsData[0].siteData[0].google_analytics_script;

        var clarityId = "";
        var googleId = "";
        if (google_analytics_script.length < 30) {
          var Gdata = google_analytics_script.split(",");
          if (Gdata[0]) {
            googleId = Gdata[0];
          }
          if (Gdata[1]) {
            clarityId = Gdata[1];
          }
        }

        window.sessionStorage.setItem("clarityId", clarityId);
        window.sessionStorage.setItem("googleId", googleId);
        window.sessionStorage.setItem(
          "siteName",
          data.siteDetailsData[0].siteData[0].siteName
        );
        window.sessionStorage.setItem(
          "book_appointment_terms",
          data.siteDetailsData[0].siteData[0].book_appointment_terms
        );
        window.sessionStorage.setItem(
          "video_chat_terms",
          data.siteDetailsData[0].siteData[0].video_chat_terms
        );
        window.sessionStorage.setItem(
          "hospital_working_time",
          data.siteDetailsData[0].siteData[0].hospital_working_time
        );
        window.sessionStorage.setItem(
          "site_url",
          data.siteDetailsData[0].siteData[0].site_url
        );
        window.sessionStorage.setItem(
          "title",
          data.siteDetailsData[0].siteData[0].title
        );
        window.sessionStorage.setItem(
          "fbPixel",
          data.siteDetailsData[0].siteData[0].fbPixel
        );
        window.sessionStorage.setItem(
          "advertisementScript",
          data.siteDetailsData[0].siteData[0].advertisementScript
        );

        window.sessionStorage.setItem(
          "termsAndCondition",
          data.siteDetailsData[0].siteData[0].termsAndCondition
        );
        window.sessionStorage.setItem(
          "privacyPolicy",
          data.siteDetailsData[0].siteData[0].privacyPolicy
        );

        window.sessionStorage.setItem(
          "hasHealthTracker",
          data.siteDetailsData[0].siteData[0].hasHealthTracker
        );
        window.sessionStorage.setItem(
          "siteLogo",
          data.siteDetailsData[0].siteData[0].logo_path
        );
        window.sessionStorage.setItem(
          "groupHospitalAdminId",
          data.siteDetailsData[0].groupHospitalAdminData[0]
            ?.groupHospitalAdminId
        );
        window.sessionStorage.setItem(
          "headerData",
          JSON.stringify(data.siteDetailsData[0].headerData)
        );

        window.sessionStorage.setItem(
          "footerData",
          JSON.stringify(data.siteDetailsData[0].footerData)
        );

        const hosDataVar = JSON.stringify(data.siteDetailsData[0].hospitalData);
        window.sessionStorage.setItem(
          "siteServices",
          JSON.stringify(data.siteDetailsData[0].services)
        );
        if (hosDataVar) {
          window.sessionStorage.setItem(
            "footerhospitalData",
            JSON.stringify(data.siteDetailsData[0].hospitalData)
          );

          window.sessionStorage.setItem(
            "footerHospitalName",
            data.siteDetailsData[0].hospitalData.hospitalName
          );
          window.sessionStorage.setItem(
            "footerHospitalcity",
            data.siteDetailsData[0].hospitalData.city
          );
          window.sessionStorage.setItem(
            "footerHospitaladdress",
            data.siteDetailsData[0].hospitalData.address
          );
          window.sessionStorage.setItem(
            "footerHospitalstateName",
            data.siteDetailsData[0].hospitalData.stateName
          );
          window.sessionStorage.setItem(
            "footerHospitalzipCode",
            data.siteDetailsData[0].hospitalData.zipCode
          );
        }
        if (data.siteDetailsData[0].themeSectionList) {
          for (
            let i = 0;
            i < data.siteDetailsData[0].themeSectionList.length;
            i++
          ) {
            window.sessionStorage.setItem(
              data.siteDetailsData[0].themeSectionList[i].themeSectionName,
              JSON.stringify(
                data.siteDetailsData[0].themeSectionList[i].themeSectionContent
              )
            );
          }
        }
        window.sessionStorage.setItem(
          "doctorDetails",
          JSON.stringify(data.siteDetailsData[0].doctorDetails)
        );

        // window.location.href = "/doctor/videoSchedule";

        // this.callLoginFunction();
        // alert("root")
        //window.location.href="/maintenance"
      }
    });
  }
   componentDidMount() {
      // $(".loader").show();
    // NEW: Set the mounted flag
    this.isMounted_ = true;

    let slug = this.props.match.params.slug;
    slug = slug.split("-");
    let doctorId = slug[0];

    // NEW: Check state for homeName, not a top-level variable
    if (!this.state.homeName) {
      window.sessionStorage.setItem("pathname", window.location.pathname);
      this.callSiteRequest();
    } else {
      // If homeName is already in sessionStorage, we can stop loading
      this.setState({ isLoading: false });
    }

   $(".loader").show();
    $(".generalFlag").hide();
    let self = this;
    window.sessionStorage.setItem("AppFlag", "NA");

    $("#callLink").hide();
    $("#chatLink").hide();
    $("#videoLink").hide();
    $("#emailLink").hide();
    $("#bookLink").hide();

    if (doctorId) {
      window.sessionStorage.setItem("doctorPID", doctorId);
    } else {
      doctorId = window.sessionStorage.getItem("doctorPID");
    }
if(!doctorId){return}
    const doctorDetails = {
      method: "POST",
      body: JSON.stringify({
        functionName: "doctorProfile",
        siteId: window.sessionStorage.getItem("siteId"),
        doctorId: doctorId,
      }),
    };
    apiCallingWithoutToken(doctorDetails).then((data) => {
      // NEW: Check if component is mounted
      if (!this.isMounted_) return;
      // console.log("doctorDetails data", data);
      if (data.success === "1") {
const validHospitalImages = data.doctorData[0].hospital_images_array.filter(
         (img) =>
  //           // Check if hospitalImage exists (not undefined, null, or empty string "")
            img.hospitalImage &&
            // Explicitly check if it's not the string "null"
            img.hospitalImage !== "null"
        );
        this.setState({
          hospitalArray: validHospitalImages,
          doctorBD: data.doctorData[0],
          seoTitle: data.doctorData[0].seoTitle,
          description: data.doctorData[0].description,
        });
        window.sessionStorage.setItem(
          "doctorName",
          data.doctorData[0].doctorName
        );
        this.setState({
          officeDetails: data.doctorData[0].officeDetails,
        });
        this.setState({
          serviceOffered: data.doctorData[0].serviceOffered,
        });
        this.setState({
          Specialities: data.doctorData[0].specialization,
        });
        this.setState({
          hospitalDetails: data.doctorData[0].hospitalDetails,
        });
        window.sessionStorage.setItem(
          "hospitalName",
          data.doctorData[0].hospitalDetails[0].name
        );
         window.sessionStorage.setItem(
          "appHosId",
          data.doctorData[0].hospitalDetails[0].hospitalId
        );
        this.setState({
          hospitalImages: data.doctorData[0].galleryImages,
        });

        data.doctorData[0].specialization.map((sp) => {
          this.setState({
            drSpecialization: this.state.drSpecialization.concat(
              sp.specialization
            ),
          });
        });

        data.doctorData[0].services.map((sp) => {
          if (sp === "Call a Doctor") {
            $("#callLink").show();
          }
          if (sp === "Messaging") {
            $("#chatLink").show();
          }
          if (sp === "Video Chat") {
            $("#videoLink").show();
          }
          if (sp === "Email Consult") {
            $("#emailLink").show();
          }
          if (sp === "Book Appointment") {
            $("#bookLink").show();
          }
        });

        if (data.doctorData[0].Favouriteflag === "1") {
          $("#dr-detail-liked .imgdislike").toggle();
          $("#dr-detail-liked .imgliked").toggle();
        }
           $(".loader").hide();
      } else {
        alert(data.errorMessage);
        window.location.href = "/";
      }
    });

    if (this.props.location.doctorList) {
      for (let i = 0; i < this.props.location.doctorList.length; i++) {
        if (
          this.props.location.doctorList[i].doctorId.toString() === doctorId
        ) {
          $("#fav").attr("checked", true);
          break;
        }
      }
    }
  }
  // componentDidMount() {
  //   let slug = this.props.match.params.slug;
  //   slug = slug.split("-");
  //   // console.log(this.props, "this is the params of this page");
  //   let doctorId = slug[0];

  //   if (authHelper.getUserId()) {
  //     this.getMedicalRecord();
  //   }
  //   if (folderName === null) {
  //     window.sessionStorage.setItem("pathname", window.location.pathname);
  //     window.location.href = "/";
  //   }
  //   $(".loadersp").show();
  //   $(".generalFlag").hide();
  //   let self = this;
  //   window.sessionStorage.setItem("AppFlag", "NA");

  //   $("#callLink").hide();
  //   $("#chatLink").hide();
  //   $("#videoLink").hide();
  //   $("#emailLink").hide();
  //   $("#bookLink").hide();
  //   //let doctorId;

  //   // if (self.props.location.doctorId) {
  //   //   window.sessionStorage.setItem("doctorPID", self.props.location.doctorId);
  //   //   doctorId = self.props.location.doctorId;
  //   // } else {
  //   //   doctorId = window.sessionStorage.getItem("doctorPID");
  //   // }
  //   if (doctorId) {
  //     window.sessionStorage.setItem("doctorPID", doctorId);
  //     doctorId = doctorId;
  //   } else {
  //     doctorId = window.sessionStorage.getItem("doctorPID");
  //   }

  //   const doctorDetails = {
  //     method: "POST",
  //     body: JSON.stringify({
  //       functionName: "doctorProfile",
  //       siteId: window.sessionStorage.getItem("siteId"),
  //       doctorId: doctorId,
  //     }),
  //   };
  //   console.log(doctorDetails.body);
  //   apiCallingWithoutToken(doctorDetails).then((data) => {

  //     if (data.success === "1") {
  //       $(".loadersp").hide();
  //       const validHospitalImages = data.doctorData[0].hospital_images_array.filter(
  //         (img) =>
  //           // Check if hospitalImage exists (not undefined, null, or empty string "")
  //           img.hospitalImage &&
  //           // Explicitly check if it's not the string "null"
  //           img.hospitalImage !== "null"
  //       );
  //       this.setState({
  //         hospitalArray: validHospitalImages,
  //         doctorBD: data.doctorData[0],
  //         seoTitle: data.doctorData[0].seoTitle,
  //         description: data.doctorData[0].description,
  //       });
  //       window.sessionStorage.setItem(
  //         "doctorName",
  //         data.doctorData[0].doctorName
  //       );
  //       this.setState({
  //         officeDetails: data.doctorData[0].officeDetails,
  //       });
  //       this.setState({
  //         serviceOffered: data.doctorData[0].serviceOffered,
  //       });
  //       this.setState({
  //         Specialities: data.doctorData[0].specialization,
  //       });

  //       this.setState({
  //         hospitalDetails: data.doctorData[0].hospitalDetails,
  //       });
  //       window.sessionStorage.setItem(
  //         "hospitalName",
  //         data.doctorData[0].hospitalDetails[0].name
  //       );
  //       this.setState({
  //         hospitalImages: data.doctorData[0].galleryImages,
  //       });

  //       // this.getCalenderData(data.doctorData[0].hospitalDetails[0].hospitalId);
  //       data.doctorData[0].specialization.map((sp) => {
  //         this.setState({
  //           drSpecialization: this.state.drSpecialization.concat(
  //             sp.specialization
  //           ),
  //         });
  //       });

  //       data.doctorData[0].services.map((sp) => {
  //         //alert(sp);
  //         if (sp === "Call a Doctor") {
  //           $("#callLink").show();
  //         }
  //         if (sp === "Messaging") {
  //           $("#chatLink").show();
  //         }
  //         if (sp === "Video Chat") {
  //           $("#videoLink").show();
  //         }
  //         if (sp === "Email Consult") {
  //           $("#emailLink").show();
  //         }
  //         if (sp === "Book Appointment") {
  //           $("#bookLink").show();
  //         }
  //       });
  //       // });
  //       // alert(data.doctorData[0].Favouriteflag);
  //       if (data.doctorData[0].Favouriteflag === "1") {
  //         $("#dr-detail-liked .imgdislike").toggle();
  //         $("#dr-detail-liked .imgliked").toggle();
  //       }
  //     } else {
  //       alert("11111")
  //       alert(data.errorMessage);
  //     }
  //   });
  //   // $("#dr-detail-liked .imgliked").hide();
  //   // $(".timeClose").on("click", function () {
  //   //   $(this).hide();
  //   //  $(".react-datepicker__time-container").hide();
  //   //   $(".react-datepicker__navigation").show();
  //   //  });
  //   // self.showService();
  //   if (this.props.location.doctorList) {
  //     for (let i = 0; i < this.props.location.doctorList.length; i++) {
  //       if (
  //         this.props.location.doctorList[i].doctorId.toString() === doctorId
  //       ) {
  //         $("#fav").attr("checked", true);
  //         break;
  //       }
  //     }
  //   }
  // }
  // componentWillMount() { }

  showService() {
    //alert(this.state.hospitalDetails);
    this.state.hospitalDetails.map((hos) => {
      // alert(hos.phoneNumber);
    });
  }

  isLoginValidate(doctorId, hospitalId, flagOption, bySlot, selDate, selTime) {
    //alert("inside" + hospitalId);
    if (this.isLoginCheck() === true) {
      if (doctorId) {
        // alert('ok')
        window.sessionStorage.setItem("loginValidate", "");
        window.sessionStorage.setItem("appDocId", doctorId);
        window.sessionStorage.setItem("appHosId", hospitalId);
        window.sessionStorage.setItem("flagOption", flagOption);
        window.sessionStorage.setItem("bySlot", bySlot);
        window.sessionStorage.setItem("selDate", selDate);
        window.sessionStorage.setItem("selTime", selTime);
        window.sessionStorage.setItem("doctor_details", "1");
        //alert();
      } else if (window.sessionStorage.getItem("appDocId")) {
        window.sessionStorage.setItem("appHosId", hospitalId);
        window.sessionStorage.setItem("flagOption", flagOption);
        // window.location.href = "/patient/bookappointment";
      } else {
      }
    } else {
      window.sessionStorage.setItem("loginValidate", "book");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("flagOption", flagOption);
      window.sessionStorage.setItem("bySlot", bySlot);
      window.sessionStorage.setItem("selDate", selDate);
      window.sessionStorage.setItem("selTime", selTime);
      window.sessionStorage.setItem("doctor_details", "1");
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
  }
  changeHospital() {
    let hosid = $("#hospitalDrop").val();
    $(".bookLink").hide();
    $(".videoLink").hide();
    $(".callLink").hide();
    $(".callLinkChat").hide();

    $("#bookLink" + hosid).show();
    $("#videoLink" + hosid).show();
    $("#callLink" + hosid).show();
    $("#callLinkChat" + hosid).show();
  }
  chatmessageClickValidate(
    doctorId,
    hospitalId,
    chatDoctorPanelId,
    textChatPrice
  ) {
    $(".loadersp").show();
    const jsonData = {
      method: "POST",
      body: JSON.stringify({
        functionName: "messageChatFree",
        chatDoctorPanelId: chatDoctorPanelId,
        memberId: authHelper.getUserId(),
        doctorId: doctorId,
        hospitalId: hospitalId,
      }),
    };
    // console.log(jsonData.body);
    apiCallingWithoutToken(jsonData).then((data) => {
      if (data.success === "1") {
        $(".loadersp").show();
        window.sessionStorage.setItem("API_KEY", data.API_KEY);
        window.sessionStorage.setItem("sessionId", data.sessionId);
        window.sessionStorage.setItem("token", data.token);
        window.sessionStorage.setItem("appDocId", doctorId);
        window.sessionStorage.setItem("appHosId", hospitalId);
        window.sessionStorage.setItem("chatDoctorPanelId", data.chatGroupId); //chatDoctorPanelId);
        window.location.href = "/chat/chatmessage";
      } else {
        // this.chatmessageClickValidate(
        //   doctorId,
        //   hospitalId,
        //   chatDoctorPanelId,
        //   textChatPrice
        // );
        alert(data.errorMessage);
      }
    });
  }
  chatmessageClick(doctorId, hospitalId, chatDoctorPanelId, textChatPrice) {
    if (this.isLoginCheck() === true) {
      this.chatmessageClickValidate(
        doctorId,
        hospitalId,
        chatDoctorPanelId,
        textChatPrice
      );
    } else {
      window.sessionStorage.setItem("loginValidate", "TextChatFree");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatDoctorPanelId);
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
  }
  isLoginValidateTextChatWithPayment(
    doctorId,
    hospitalId,
    chatdoctorpanelid,
    messaging_cost
  ) {
    if (this.isLoginCheck() === true) {
      window.sessionStorage.setItem("loginValidate", "");
      // alert(doctorId);
      // alert(hospitalId);
      // alert(chatdoctorpanelid);
      // alert(messaging_cost);
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatdoctorpanelid);
      window.sessionStorage.setItem("messaging_cost", messaging_cost);
      window.location.href = "/patient/textchatpayment";
    } else {
      window.sessionStorage.setItem("loginValidate", "TextChatPay");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatdoctorpanelid);
      window.sessionStorage.setItem("messaging_cost", messaging_cost);
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
  }
  getHospitalId() {
    const { hospitalDetails } = this.state;

    // if (!hospitalDetails || !Array.isArray(hospitalDetails.hospitalServices)) {
    //   console.warn("Hospital details or services are unavailable.");
    //   return "Not ";
    // }

    const service = hospitalDetails[0]?.hospitalServices?.find(
      (s) => s.serviceName === "Book Appointment"
    );
    return service?.hospitalId || "Not Found";
  }
  srcErrorImage(ev) {
    ev.target.src = DoctorImg;
  }
  goToAppointment() {
    this.setState({ selectedTab: 1 })
  }

  srcDrImage() {
    const doctorAvatar = this.state.doctorBD.image?.split("/").pop();
    const isDefault =
      doctorAvatar === "avatarGirlDefault.png" ||
      doctorAvatar === "avatarBoyDefault.png";

    return (
      <img
        onError={this.srcErrorImage}
        src={isDefault ?
          DoctorImg : this.state.doctorBD.image
        }
        className="w-100 h-100"
        width={150}
        height="180"
        alt=""
      ></img>
    )
  }

  getMedicalRecord() {
    const apiJson = {
      method: "POST",
      body: JSON.stringify({
        functionName: "healthRecords/patient/showDetails",
        userId: authHelper.getUserId(),
        max: "0",
        offset: "10",
        fromInput: "",
        otp: "",
        mobileNumber: "",
      }),
    };
    // console.log(apiJson.body)
    apiCalling(apiJson).then((data) => {
      if (data.success === "1") {
        //alert()
        this.setState({
          healthRecords: data.healthRecords,
        });
      }
    });
  }

  render() {
    var dateSettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            swipeToSlide: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            swipeToSlide: true,
          },
        },
      ],
    };
    const ensureExternalUrl = (url) => {

      if (url && !/^https?:\/\//i.test(url)) {
        return `http://${url}`; // Prepend 'http://' to make it an absolute URL
      }
      return url; // Return the URL as is (or null if it was null/undefined)
    };
    const getMapUrl = (data) => {
      // 1. Construct the full, readable address string
      const fullAddress = `${data.name}, ${data.address}, ${data.state} ${data.zip || ''}`;

      // 2. Encode the string to be safely used in a URL query parameter
      const encodedAddress = encodeURIComponent(fullAddress);

      // 3. Return the Google Maps search URL
      // The 'q=' parameter is used for a direct search query (address, name, etc.)
      return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    };
     const DynamicHeader = React.lazy(() => import(`../${this.state.homeName}/header`));
        const DynamicFooter = React.lazy(() => import(`../${this.state.homeName}/footer`));
         if (this.state.isLoading) {
      return <div>Loading...</div>;
    }
    return (
      
      <div className="purpleWrap">
        <Suspense fallback={<div></div>}>
          <section>
            {!this.state.isLoading?
            <DynamicHeader />:""}
          </section>
        </Suspense>
        <Helmet>
          <title>{this.state.seoTitle}</title>
          <meta name="description" content={this.state.description} />
        </Helmet>
        <div class="loadersp"></div>
        <div className="main-container">
          
          <div className="breadcrumb-head">
            <div className="breadcrumb-div">
              <ul className="bread-crumb-ul">
                <li className="breadcrumb-light">Home</li>
                <li>
                  <RiArrowRightSLine />
                </li>
                <li className="breadcrumb-light">
                  <Link to="/home/doctor-list-main/0">Doctors</Link>
                </li>
                <li>
                  <RiArrowRightSLine />
                </li>
                {this.state.doctorBD.doctorName && (
                <li className="breadcrumb-active">{this.state.doctorBD.doctorName}, {this.state.doctorBD.doctorEducation}</li>
                )}
              </ul>
            </div>
           
            <div className="user-header">
               <img src={Arrowleft} alt="arrowleft" className="img-fluid cursor-pointer"
                 onClick={() => {
     window.location.href = "/";
  }}/>
                {this.state.doctorBD.doctorName && (
                  <>
             
              {this.state.doctorBD.doctorName}, {this.state.doctorBD.doctorEducation}
              </>
                )}
            </div>
          </div>
          <div className="overview-container">
            <div className="doctor-overview-left">
              <div className="common-card">
                <h4 className="overview-heading">
                  Overview
                </h4>
                <div className="doctor-outer-img">
                  <div className="doctor-container">
                    <div className="doctor-inner-img">
                      {this.srcDrImage()}
                      {/* <img
                        className="img-fluid w-100"
                        // src={DoctorImg}
                        onError={this.srcErrorImage}
                        srcDrImage
                        src={doctorAvatar == "avatarGirlDefault.png" || "avatarBoyDefault.png" ?
                          DoctorImg : this.state.doctorBD.image
                        }
                        width="350"
                        height="150"
                        alt=""
                      ></img> */}
                    </div>
                    <div className="doctor-inner-name mt-3"> {this.state.doctorBD.doctorName}</div>
                    <p className="doctor-inner-description">
                      {this.state.doctorBD?.hospitalDetails?.[0]?.name}
                    </p>
                  </div>
                  <div className="dr-specialist-flex">
                    <span class="drspecialist-Name">
                      {this.state.doctorBD.primarySpeciality}
                    </span>
                    {/* <div className="drlist-rating">
                          <img src={Star} alt="star" className="img-fluid pr-1" width="17" 
                          style={{marginTop:"-3px"}}/>
                          4.8
                        </div> */}
                  </div>

                  <div>
                    <h4 className="mb-0 sub-heading text-left mt-5 mb-3">
                      Basic info
                    </h4>
                    {this.state.doctorBD.emailId &&
                    <p class="drspecialist-content text-left d-flex mb-3">
                      <span className="mr-2" style={{ lineHeight: "16px" }}><HiOutlineEnvelope size={15} /></span>
                      <a className="drspecialist-span" title="Click to send mail" href={`mailto:${this.state.doctorBD.emailId}`} >
                        {this.state.doctorBD.emailId}
                      </a>
                    </p>}
                    {this.state.doctorBD?.hospitalDetails?.map((data) => (
                      <div className="mb-5">
                        <p class="drspecialist-content text-left d-flex mb-3">
                          <span className="mr-2" style={{ lineHeight: "16px" }}><SlLocationPin size={15} /></span>
                          <a className="drspecialist-span" target="_blank" title="Click search in google map" href={getMapUrl(data)} >
                            {data.name}, {data.address}, {data.state} {data.zip && (` -  ${data.zip}`)}
                          </a>
                        </p>
                        {data?.phoneNumber &&
                          <p class="drspecialist-content text-left d-flex mb-3">
                            <span className="mr-2" style={{ lineHeight: "16px" }}><IoCallOutline size={15} /></span>
                            <a className="drspecialist-span" title="click to make a call" href={`tel:${data.phoneNumber.replace(/[\s()-]/g, '')}`}>
                              {data?.phoneNumber}
                            </a>
                          </p>
                        }
                        {data?.websiteUrl &&
                          <p class="drspecialist-content text-left d-flex mb-2">
                            <span className="mr-2" style={{ lineHeight: "16px" }}><IoGlobe size={15} /></span>
                            <a className="drspecialist-span cursor-pointer" title="click to visit" href={ensureExternalUrl(data?.websiteUrl)} target="_blank">
                              {data?.websiteUrl}
                            </a>
                          </p>
                        }
                      </div>
                    ))}
                    <button type="button" className="book-btn position-book-btn"
                      onClick={this.goToAppointment}
                    >Book appointment</button>
                  </div>
                  {/*<p class="drspecialist-text mb-0">{this.state.doctorBD.city}</p> */}
                  {/* {this.state.hospitalDetails.length !== 1 && (
                        <p className="mb-0">
                          <select
                            class="drspecialist-hospital"
                            onClick={(e) => this.changeHospital()}
                            id="hospitalDrop"
                          >
                            {this.state.hospitalDetails.map((hospial) => {
                              return (
                                <option value={hospial.hospitalId}>
                                  {hospial.name}
                                </option>
                              );
                            })}
                          </select>
                        </p>
                      )} */}
                  {/* <span class="profileAvailable">
                        <img src={correct} width="17"></img>Available
                      </span> */}
                </div>
                {/* <div
                      className="drServiceMain"
                      id={"drServiceMain" + this.props.consti}
                    >
                      <div className="drService-subhead">SERVICES:</div>

                      {this.state.hospitalDetails.map((hos, index) => {
                        let services = hos.hospitalServices;
                        //let priceDetails = hos.priceDetails;
                        // alert(services);
                        let bookShow = "none";
                        let vcShow = "none";
                        let auShow = "none";
                        let chat = "none";
                        let show = index === 0 ? "block" : "none";
                        services.map((it) => {
                          // alert(it.serviceName)
                          if (
                            it.serviceName === "Book Appointment" &&
                            it.status === 1
                          ) {
                            bookShow = "Book Appointment";
                          }
                          if (it.serviceName === "Video Chat" && it.status === 1) {
                            vcShow = "Video Chat";
                          }
                          if (it.serviceName === "Call a Doctor" && it.status === 1) {
                            auShow = "Call a Doctor";
                          }
                          if (it.serviceName === "Messaging" && it.status === 1) {
                            chat = "Messaging";
                          }
                        });
                        // alert(hos.priceDetails[0].textChatPrice);
                        return (
                          <div>
                            {bookShow === "Book Appointment" && (
                              <div
                                className="drServiceSp drServiceSp-book generalFlag bookLink"
                                id={"bookLink" + hos.hospitalId}
                                style={{ display: show }}
                              >
                                <span
                                  className="text-decoration-none drServiceSpSpan"
                                  return
                                  onClick={(e) => {
                                    this.isLoginValidate(
                                      this.props.location.doctorId,
                                      hos.hospitalId,
                                      "p",
                                      "No",
                                      "",
                                      ""
                                    );
                                  }}
                                >
                                  <img src={inperson} alt=""></img> In-Person
                                  <span className="drService-rate">
                                    {hos.priceDetails[0].inPersonprice != "0.00" &&
                                      "₹" + hos.priceDetails[0].inPersonprice}
                                  </span>
                                </span>
                              </div>
                            )}
                            {vcShow === "Video Chat" && (
                              <div
                                className="drServiceSp drServiceSp-videochat generalFlag videoLink"
                                id={"videoLink" + hos.hospitalId}
                                style={{ display: show }}
                              >
                                <span
                                  className="text-decoration-none drServiceSpSpan"
                                  onClick={(e) => {
                                    this.isLoginValidate(
                                      this.props.location.doctorId,
                                      hos.hospitalId,
                                      "v",
                                      "No",
                                      "",
                                      ""
                                    );
                                  }}
                                >
                                  <img src={videog} alt=""></img> Video Chat
                                  <span className="drService-rate">
                                    ₹ {hos.priceDetails[0].videoChatPrice}
                                  </span>
                                </span>
                              </div>
                            )}
                            {auShow === "Call a Doctor" && (
                              <div
                                className="drServiceSp drServiceSp-call generalFlag callLink"
                                id={"callLink" + hos.hospitalId}
                                style={{ display: show }}
                              >
                                <span
                                  className="text-decoration-none drServiceSpSpan"
                                  onClick={(e) => {
                                    this.isLoginValidate(
                                      this.props.location.doctorId,
                                      hos.hospitalId,
                                      "c",
                                      "No",
                                      "",
                                      ""
                                    );
                                  }}
                                >
                                  <img src={phoneg} alt=""></img> Audio Chat
                                  <span className="drService-rate">
                                    ₹ {hos.priceDetails[0].audioPrice}
                                  </span>
                                </span>
                              </div>
                            )}
                            {chat === "Messaging" && (
                              <div
                                className="drServiceSp drServiceSp-chat callLinkChat"
                                id={"callLinkChat" + hos.hospitalId}
                                style={{ display: show }}
                              >
                                {hos.priceDetails[0].textChatPrice !== "0.00" ? (
                                  <span
                                    onClick={(e) => {
                                      this.isLoginValidateTextChatWithPayment(
                                        this.props.location.doctorId,
                                        hos.hospitalId,
                                        hos.chatDoctorPanelId,
                                        hos.priceDetails[0].textChatPrice
                                      );
                                    }}
                                    className="text-decoration-none drServiceSpSpan"
                                  >
                                    <img src={chatg} alt=""></img> Text Chat
                                    <span className="drService-rate">
                                      ₹{hos.priceDetails[0].textChatPrice}
                                    </span>
                                    <span className="expireDay">
                                      {this.state.doctorBD.daysOfExpiry &&
                                        "Days of Expiry :" +
                                          this.state.doctorBD.daysOfExpiry}
                                    </span>
                                  </span>
                                ) : (
                                  <span
                                    onClick={() =>
                                      this.chatmessageClick(
                                        this.props.location.doctorId,
                                        hos.hospitalId,
                                        hos.chatDoctorPanelId,
                                        hos.priceDetails[0].textChatPrice
                                      )
                                    }
                                    className="text-decoration-none drServiceSpSpan"
                                  >
                                    <img src={chatg} alt=""></img> Text Chat
                                    <span className="drService-rate">
                                      {" "}
                                      ₹{hos.priceDetails[0].textChatPrice}
                                    </span>
                                    <span className="expireDay">
                                      {this.state.doctorBD.daysofexpiry &&
                                        "Days of Expiry : " +
                                          this.state.doctorBD.daysofexpiry}
                                    </span>
                                  </span>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div> */}
              </div>
            </div>
            <div className="doctor-overview-right">

              <Tabs
                selectedIndex={this.state.selectedTab}
                onSelect={(index) => this.setState({ selectedTab: index })}>
                <TabList>
                  <Tab>
                    <span className="drDetSpanUnderline">Overview</span>
                  </Tab>
                  <Tab onClick={(e) => {
                    this.isLoginValidate(
                      this.props.location.doctorId,
                      this.getHospitalId(),
                      // this.state.hospitalDetails.filter((data) => data.hospitalServices.include("Book Appointment")) return service.hospitalId),
                      "p",
                      "No",
                      "",
                      ""
                    );
                  }}>
                    <span className="drDetSpanUnderline">Appointment</span>
                  </Tab>
                  <Tab>
                    <span className="drDetSpanUnderline">Specialities</span>
                  </Tab>
                  <Tab>
                    <span className="drDetSpanUnderline">Service offered</span>
                  </Tab>
                  <Tab>
                    <span className="drDetSpanUnderline">Office details</span>
                  </Tab>
                  {this.state.appType !== "p" && window.sessionStorage.getItem("userId")? (
                    <Tab>
                      <span className="drDetSpanUnderline">Medical Records</span>
                    </Tab>
                  ):""}
                </TabList>

                <TabPanel>
                  <div>
                    <div className="main-detail-head">Overview</div>
                   

                        {this.state.doctorBD?.hospitalDetails?.map((data) => (
                           <div className="doctor-details-div">


                      <div className="">
                          <div className="row" key={data.hospitalId} style={{ gap: '15px 0' }}>
                            <div className="col-md-12">
                              <h4 className="sub-heading mb-0">
                                About
                              </h4>
                              <p className="doctor-details-p mb-4 col-lg-9 px-0 col-12">{this.state.doctorBD.professionalStatement}</p>
                              <h4 className="sub-heading mb-0">
                                Info
                              </h4>
                              <p className="font-bold mb-2 doctor-detail-sub2">{data.name}</p>
                              <p className="mb-0 doctor-details-p col-lg-8 px-0 col-12">
                                {data.address}
                              </p>
                              <p className="mb-0 doctor-details-p col-lg-8 px-0 col-12">
                                {data.state}, {data.country}
                              </p>
                              {data.zip &&
                                <p className="doctor-details-p">ZIP - {data.zip}</p>
                              }
                              {data.phoneNumber &&
                                <p className="mt-3 doctor-details-p mb-0">Phone - {data.phoneNumber}</p>
                              }
                            </div>
                            <div className="col-lg-6">
                              <iframe
                                src={
                                  "https://maps.google.com/maps?q=" +
                                  data.latitude +
                                  "," +
                                  data.longitude +
                                  "&z=15&output=embed"
                                }
                                width="100%"
                                height="250"
                                frameborder="0"
                                allowfullscreen=""
                              ></iframe>

                            </div>
                            {this.state.hospitalArray.length > 0 && (
                              <div className="col-lg-6 mx-auto">
                                <GallerySlider hospital_images_array={this.state.hospitalArray} />
                              </div>
                            )}
                          </div>
                           </div>
                    </div>
                        ))}

                     
                  </div>

                </TabPanel>
                <TabPanel>
                  <Bookappointment />
                </TabPanel>
                <TabPanel>
                  <div className="main-detail-head">Specialities</div>
                  <div className="doctor-details-div">

                    {/* <div class="form-head"> </div> */}
                    {this.state.Specialities.map((s) => {
                      return (
                        <ul className="pl-1 mb-0 ul-list">
                          <li>{s.specialization ? s.specialization : ""}</li>
                        </ul>
                      );
                    })}
                    {this.state.Specialities.length === 0 && "No Data Available"}
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="main-detail-head">Service Offered</div>
                  <div className="doctor-details-div">
                    {/* <div class="form-head"> </div> */}
                    {/* {this.state.serviceOffered.map((s) => {
                  return (
                    <ul className="pl-1 mb-0 ul-list">
                      <li>
                        <img src={Serviceimg} alt="Serviceimg" className="img-fluid pr-2"/>
                        {s.serviceOffered}</li>
                    </ul>
                  );
                })} */}
                    {this.state.serviceOffered.map((s, index) => {
                      return <div key={index} className="service-ul">

                        {renderHTML(s.serviceOffered)}
                      </div>;
                    })}

                    {this.state.serviceOffered[0] && this.state.serviceOffered[0].serviceOffered == "" && "No Data Available"}
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="main-detail-head">Office Details</div>
                  <div className="doctor-details-div">
                    {/* <div class="form-head"> </div> */}

                    {/* {this.state.officeDetails.map((s) => {
                  return  */}
                    <div>
                      {/* {renderHTML(s.officeDetails)} */}
                      <p className="font-bold mb-2 doctor-detail-sub2">{this.state.doctorBD.seoTitle}</p>
                      {/* <p className="mb-0 doctor-details-p col-lg-8 px-0 col-12">
                      {this.state.doctorBD.address}, {this.state.doctorBD.state}, {this.state.doctorBD.country}
                    </p> */}
                      {this.state.doctorBD.zip && (
                        <p className="doctor-details-p">Pincode - {this.state.doctorBD.zip}</p>
                      )}
                      <p className="mt-4 doctor-details-p">Phone - {this.state.doctorBD.mobileNumber}</p>
                    </div>
                    {/* })} */}
                    {this.state.officeDetails.length === 0 && "No Data Available"}
                  </div>
                </TabPanel>
                <TabPanel>
                  <div class="main-detail-head">Medical Records</div>
                  <div class="doctor-details-div">
                    <HealthDocumentList
                      healthRecords={this.state.healthRecords}
                    ></HealthDocumentList>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
          {/* <div
            className="drDetailServicemain py-3 text-left"
            style={{ float: "none" }}
          >
            <a href="#">
              <span className="drDetailServiceSpan">
                <img src={speciality} class="imgshow-act" width="22"></img>
                <span className="drDetSpanUnderline">specialities</span>
              </span>
            </a>
            <a href="#">
              <span className="drDetailServiceSpan">
                <img src={service} class="imgshow-act" width="22"></img>
                <span className="drDetSpanUnderline">service offered</span>
              </span>
            </a>
            <a href="#">
              <span className="drDetailServiceSpan">
                <img src={hospital} class="imgshow-act" width="22"></img>
                <span className="drDetSpanUnderline">office details</span>
              </span>
            </a>
          </div> */}
        </div>
        <Suspense fallback={<div></div>}>
          <section>
              {!this.state.isLoading?
            <DynamicFooter />:""}
          </section>
        </Suspense>
      </div>
    );
  }
}
